import React from "react";
import { useAuth } from "@/context/AuthContext";

export default function AdminSettings() {
  const { user } = useAuth();
  return (
    <div data-testid="admin-settings-page">
      <div className="text-xs uppercase tracking-[0.2em] text-[#2563eb] font-semibold">Settings</div>
      <h1 className="mt-1 font-display font-bold text-3xl text-[#0f1b2d]">Admin settings</h1>

      <div className="mt-8 max-w-2xl bg-white border border-[#e2e8f0] rounded-lg p-6">
        <h3 className="font-display font-bold text-lg text-[#0f1b2d]">Profile</h3>
        <div className="mt-4 space-y-3 text-sm">
          <Row label="Name" value={user?.name} />
          <Row label="Email" value={user?.email} />
          <Row label="Role" value={user?.role} />
        </div>
      </div>

      <div className="mt-6 max-w-2xl bg-white border border-[#e2e8f0] rounded-lg p-6">
        <h3 className="font-display font-bold text-lg text-[#0f1b2d]">Packages</h3>
        <p className="mt-2 text-sm text-[#475569]">Package prices are configured server-side for security. To change them, update <code className="text-xs bg-[#f1f5f9] px-1.5 py-0.5 rounded">PACKAGES</code> in <code className="text-xs bg-[#f1f5f9] px-1.5 py-0.5 rounded">backend/server.py</code>.</p>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between border-b border-[#f1f5f9] py-2 last:border-0">
      <span className="text-[#64748b]">{label}</span>
      <span className="text-[#0f1b2d] font-medium">{value}</span>
    </div>
  );
}
